
import { buildResourcePath } from '@/utils'
export default {
  filters: {
    fullpath: function(input) {
      return buildResourcePath(input)
    }
  }
}